import React, { FC, useCallback, useMemo } from "react";
import { scroller } from "react-scroll";

import Pagination, { IPaginationProps } from "@/apps/ui/components/Pagination";

import { GetPartsWithPriceType } from "../../selectors/getPartsWithPrice";
import { LoadPartsType } from "../../store/parts/actions";

import style from "./style.css";

const scrollToForm = () => {
  scroller.scrollTo("part-price-form", {
    smooth: true,
    duration: 200,
  });
};

interface IPaginationComponentProps extends Partial<IPaginationProps> {
  loadParts: LoadPartsType;
  parts: GetPartsWithPriceType;
  query?: string;
}

// общее количество страниц указывается значением помноженным на 10
// pageSize: https://github.com/react-component/pagination#api
const paginationPageSize = 10;

const PaginationComponent: FC<IPaginationComponentProps> = ({ loadParts, query, total, current, disabled, parts }) => {
  const onChange = useCallback(
    (page: number) => {
      if (query) {
        loadParts(query, page);
        scrollToForm();
      }
    },
    [query],
  );

  const isHasParts = useMemo(() => Array.isArray(parts) && parts.length > 0, [parts]);
  const totalPages = useMemo(() => total && total * paginationPageSize, [total]);
  const isVisible = isHasParts && totalPages && totalPages > paginationPageSize;

  return (
    <>
      {isVisible && (
        <Pagination
          className={style.pagination}
          onChange={onChange}
          total={totalPages}
          current={current}
          disabled={disabled}
        />
      )}
    </>
  );
};

export default PaginationComponent;
